export default __webpack_public_path__ + "static/home_automation_bex-79214f32d57e864f75579a3ae034a8de.png";